import horizontal from "./horizontal";
import Vertical from "./Vertical";
const layoutsCommponents={
     horizontal,
     Vertical
}
export default layoutsCommponents